<form
  #tForm
  [action]="endpoint()"
  method="get" style="display: none">
  <input [value]="clientId()" name="client_id">
  <input [value]="redirectUri()" name="redirect_uri">
  <input [value]="scope()" name="scope">
  <input name="response_type" value="code">
  <input [value]="state()" name="state">
  <button type="submit">send</button>
</form>


<button matButton="filled"
        [disabled]="!endpoint()"
        (click)="tForm.submit()">
  <div class="button">
    <img
      alt="login with gitlab icon" src="gitlab.png" width="40">
    @if (endpoint()) {
      Identify with GitLab
    } @else {
      <mat-progress-bar mode="buffer"/>
    }
  </div>
</button>
